import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import MoodIcon from "@mui/icons-material/Mood";
import TranslateIcon from "@mui/icons-material/Translate";
import ShieldIcon from "@mui/icons-material/Shield";

export default function AIAnnouncementModal({ open, onClose, onExplore }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: "rounded-[32px] border-none overflow-hidden shadow-2xl",
        sx: {
          backgroundColor: "transparent",
        },
      }}
    >
      <Box className="relative bg-white dark:bg-gray-900 overflow-hidden">
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            zIndex: 1000,
            backgroundColor: 'rgba(0,0,0,0.05)',
            backdropFilter: 'blur(4px)',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.1)',
            },
            color: 'text.primary'
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent className="p-0">
          <div className="flex flex-col md:flex-row min-h-[500px]">
            {/* Left side: Visual/Icon */}
            <Box className="w-full md:w-[40%] bg-gradient-to-br from-indigo-700 via-primary-600 to-indigo-800 p-12 flex flex-col items-center justify-center text-white text-center">
              <div className="relative mb-8">
                  <div className="absolute inset-0 bg-white/20 rounded-full blur-2xl animate-pulse" />
                  <SmartToyIcon sx={{ fontSize: 100 }} className="relative z-10" />
              </div>
              <Typography variant="h4" className="font-bold mb-4 tracking-tight">
                Mood-Aware AI
              </Typography>
              <Typography variant="body1" className="text-indigo-100 font-medium">
                The first social media assistant that actually understands how your customers feel.
              </Typography>
            </Box>

            {/* Right side: Marketing Copy */}
            <Box className="w-full md:w-[60%] p-10 md:p-14 flex flex-col justify-center">
              <Typography variant="overline" className="text-primary-600 dark:text-primary-400 font-black tracking-[0.2em] uppercase mb-4 block">
                Brand Protection v2.0
              </Typography>
              <Typography variant="h4" className="font-extrabold mb-8 text-gray-900 dark:text-white leading-[1.2]">
                Never miss a "Fake" claim or a "Shipping" query again.
              </Typography>

              <div className="space-y-8 mb-10">
                <div className="flex gap-5">
                  <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-pink-50 dark:bg-pink-900/20 flex items-center justify-center">
                    <MoodIcon className="text-pink-500" />
                  </div>
                  <div>
                    <Typography className="font-bold text-gray-900 dark:text-white text-lg">Mood Recognition</Typography>
                    <Typography variant="body2" className="text-gray-600 dark:text-gray-400 text-base">
                      Recognizes angry vs. happy customers and adapts its tone instantly to prevent escalation.
                    </Typography>
                  </div>
                </div>

                <div className="flex gap-5">
                  <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center">
                    <TranslateIcon className="text-blue-500" />
                  </div>
                  <div>
                    <Typography className="font-bold text-gray-900 dark:text-white text-lg">Hinglish & Regional Detection</Typography>
                    <Typography variant="body2" className="text-gray-600 dark:text-gray-400 text-base">
                      Flawlessly understands regional languages written in English script.
                    </Typography>
                  </div>
                </div>

                <div className="flex gap-5">
                  <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-green-50 dark:bg-green-900/20 flex items-center justify-center">
                    <ShieldIcon className="text-green-500" />
                  </div>
                  <div>
                    <Typography className="font-bold text-gray-900 dark:text-white text-lg">Reputation Shield</Typography>
                    <Typography variant="body2" className="text-gray-600 dark:text-gray-400 text-base">
                      AI pre-emptively rebuts public accusations like "Scam" or "Fake" to protect your trust.
                    </Typography>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-auto">
                <Button
                  variant="contained"
                  fullWidth
                  className="btn-primary py-4 font-black rounded-2xl shadow-xl shadow-primary-500/20"
                  onClick={() => {
                    onExplore();
                    onClose();
                  }}
                >
                  Configure your Post
                </Button>
                <Button
                  variant="text"
                  fullWidth
                  className="text-gray-500 font-bold hover:bg-gray-50"
                  onClick={onClose}
                >
                  Learn More First
                </Button>
              </div>
            </Box>
          </div>
        </DialogContent>
      </Box>
    </Dialog>
  );
}
